// Helpers PUROS de picking de elementos (sin motor de render ni `this`). El motor aporta
// solo la conversión de coordenadas (puntero→local y local→pantalla); aquí vive la
// matemática agnóstica, que sobrevive al cambio de motor Konva→Three.js. Esta es la
// "costura de picking" del plan de migración.

// Entidad bajo un punto EN COORDS LOCALES del bloque (rects axis-aligned). El último que
// coincide gana (los de encima se dibujan después). Devuelve la entidad o null.
export function findEntityAtLocalPoint(entities, point) {
  if (!entities || !entities.length || !point) return null
  for (let i = entities.length - 1; i >= 0; i--) {
    const e = entities[i]
    if (point.x >= e.x && point.x <= e.x + e.width &&
        point.y >= e.y && point.y <= e.y + e.height) {
      return e
    }
  }
  return null
}

// Geometría en PANTALLA de una entidad para colocar el popover: centro (ancla) + rect
// (box). Proyecta sus esquinas con `project(point) => {x,y}`, que aporta el motor. Pura.
export function buildElementScreenGeometry(entity, project) {
  const c = project({ x: entity.x + entity.width / 2, y: entity.y + entity.height / 2 })
  const p1 = project({ x: entity.x, y: entity.y })
  const p2 = project({ x: entity.x + entity.width, y: entity.y + entity.height })
  return {
    anchor: { x: c.x, y: c.y },
    box: {
      left: Math.min(p1.x, p2.x),
      top: Math.min(p1.y, p2.y),
      right: Math.max(p1.x, p2.x),
      bottom: Math.max(p1.y, p2.y),
    },
  }
}
